import type { TourStepData } from './types';

export const campaignsTourSteps: TourStepData[] = [
  {
    target: '[data-tour="campaigns-header"]',
    title: 'Campaigns',
    content:
      'Le module Campaigns (Campagnes) permet de creer, suivre et mesurer vos campagnes marketing avec les KPIs de conversion et de ROI (Retour sur investissement).',
    placement: 'bottom',
    glossaryTerm: 'campaigns',
  },
  {
    target: '.fc-card',
    title: 'Tableau des campagnes',
    content:
      'Visualisez toutes vos campagnes avec leur statut, dates, metriques de tracking et liens vers les contenus associes.',
    placement: 'bottom',
    glossaryTerm: 'roi',
  },
];
